// STC-specific configuration for the hosted PWA.
// These values are baked in at build time — no runtime lookup needed.
export const CONFIG = {
  clientId: '4cad2b2d-cfe2-462c-8b2b-c62c9b491389',
  tenantId: '3c0e71ec-41d3-4504-a032-9e1cbc7bb9a5',
  scopes: ['Chat.Read', 'Files.Read.All', 'OnlineMeetings.Read', 'User.Read'],
};
